import { css } from '@emotion/react'
import { fonts, fontSizes, fontWeights } from '@opallabs/pulsar'
import { colors } from '@opallabs/spectrum'

export const headerContainer = css({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  padding: '14px 25px 0 16px',
})

export const headerSubContainer = css({
  alignItems: 'center',
  display: 'flex',
})

export const header = css({
  paddingLeft: 9,
})

export const withCollab = 'with-collab'
const withCollabSelector = `.kuiper-${withCollab}`

export const accountContainer = css({
  alignItems: 'center',
  display: 'flex',
  maxWidth: 262,
  whiteSpace: 'nowrap',
  [`&${withCollabSelector}`]: {
    minWidth: 0,
    overflow: 'hidden',
  },
  [`&${withCollabSelector} .kuiper-account-name`]: {
    flex: '0 1 auto',
    maxWidth: 'none',
    minWidth: 0,
  },
})

export const account = css({
  color: colors.orange.base,
})

export const accountName = (accountName: string) =>
  css({
    color: accountName ? colors.n1.base : colors.orange.base,
    display: 'block',
    fontFamily: fonts.helvetica,
    fontSize: 14,
    fontWeight: fontWeights.bolder,
    maxWidth: 154,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  })

export const locationContainer = css({
  fontSize: 14,
  margin: '1px 2px 0px 4px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
})

export const locationText = css({
  fontFamily: fonts.helvetica,
  fontWeight: 'bold',
})

export const scheduledTimeContainer = css({
  alignItems: 'center',
  display: 'flex',
  marginTop: 2,
})

export const scheduledTime = css({
  alignItems: 'center',
  color: '#606770',
  display: 'flex',
  fontFamily: fonts.sansSerif,
  fontSize: fontSizes.small,
  paddingRight: 4,
  '.kuiper-icon-wrapper': {
    margin: '-1px 0 0 4px',
  },
})

export const scheduledTimeSeparator = css({
  fontSize: fontSizes.xxxLarge,
  fontWeight: fontWeights.bolder,
  lineHeight: 0.1,
  paddingBottom: 2,
})

export const collabAvatarContainer = css({
  height: '40px',
  width: '40px',
  position: 'relative',
  div: {
    display: 'block',
  },
  'div:nth-of-type(2)': {
    marginLeft: '14px',
    marginTop: '-18px',
    display: 'block',
    position: 'absolute',
  },
})

export const collabAvatarSecondary = css({
  backgroundColor: 'rgb(208, 218, 225)',
})

export const collabSeparator = css({
  flexShrink: 0,
  fontFamily: fonts.helvetica,
  fontSize: 14,
  whiteSpace: 'pre',
})

export const emptyCollabName = css({
  display: 'block',
  fontFamily: fonts.helvetica,
  fontSize: 14,
  fontWeight: fontWeights.bolder,
  maxWidth: 100,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
})

export const moreIconContainer = css({
  color: '#65686B',
  display: 'flex',
  flexDirection: 'column',
  paddingTop: 8,
})
